import {
  login,
  logout,
  getUserProfile,
  getAccountList,
  changeRole,
  changeScope,
  createAccount,
  deleteAccount,
} from '@/api/user';

const user = {
  state: {
    email: '',
    token: '',
    role: '',
  },
  mutations: {
    SET_TOKEN: (state, payload) => {
      state.token = payload.token;
      localStorage.token = state.token;
    },
    DEL_TOKEN: (state) => {
      state.token = '';
      localStorage.token = '';
      localStorage.email = '';
    },
    SET_USER: (state, payload) => {
      state.email = payload.email
      localStorage.email = payload.email
      localStorage.role = payload.role
    },
  },
  actions: {
    Login({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        login(data.email, data.password).then((res) => {
          commit('SET_TOKEN', res);
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    Logout({
      commit,
    }) {
      return new Promise((resolve, reject) => {
        logout().then((res) => {
          // console.log(res);
          if (res.result === 'success') {
            commit('DEL_TOKEN');
          }
          resolve(localStorage.token);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    GetProfile({
      commit,
    }) {
      return new Promise((resolve, reject) => {
        getUserProfile().then((res) => {
          console.log('set user', res);
            commit('SET_USER', res);
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
  },
};
export default user;
